import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '',
  scrollBehavior () {
    document.getElementById('website').scrollIntoView()
  },
  routes: [{
    path: '/not-found',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "pageNotFound" */ './views/NotFound.vue')
  },
  // {
  //   path: '/login',
  //   name: 'tmpLogin',
  //   component: () => import(/* webpackChunkName: "pageHome" */ './views/TmpLogin.vue')
  // },
  {
    path: '/:lang?',
    component: {
      render: h => h('router-view')
    },
    children: [
      // {
      //   path: 'Home',
      //   redirect: '/'
      // },
      {
        path: 'index.html',
        redirect: '/'
      },
      {
        path: '',
        name: 'homePage',
        // alias: 'Home',
        component: () => import(/* webpackChunkName: "pageContent" */ './views/ContentPage.vue')
      },
      {
        path: ':page',
        name: 'contentPage',
        component: () => import(/* webpackChunkName: "pageContent" */ './views/ContentPage.vue')
      }
    ]
  },
  {
    path: '*',
    redirect: '/not-found'
  }
  ]
})

router.beforeEach((to, from, next) => {
  if (store.state.isAdmin && store.state.hasContentChanges) {
    if (!confirm('Unsaved changes! Do you want to continue?')) {
      return false
    }
  }
  if (to.name === 'notFound' || to.name === 'fileNotFound') {
    store.dispatch('getSitemap', (from.name === null ? 'init' : false)).then(function (suc) {
      if (to.redirectedFrom && to.name === 'notFound' && /(\/files\/)|(\/data\/)/gi.test(to.redirectedFrom.toLowerCase())) {
        const urlCulture = to.redirectedFrom.replace(/(\/files\/)|(\/data\/)/gi, '').split('/')[0]
        const culture = urlCulture && store.state.cultures.hasOwnProperty(urlCulture) ? urlCulture : Object.keys(store.state.cultures)[0]
        next({
          path: '/' + culture + '/Downloads'
        })
        store.dispatch('setSnack', {
          title: 'File not found',
          message: to.redirectedFrom,
          color: 'danger',
          public: true,
          duration: 6000
        })
      } else {
        next()
      }
      return false
    })
  } else {
    store.dispatch('getSitemap', (from.name === null ? 'init' : false)).then(function (suc) {
      if (suc) {
        var isHome = to.name === 'homePage' || to.params.page === store.state.homepage
        var name = isHome ? store.state.homepage : to.params.page
        const cultures = store.state.cultures
        if (to.params.lang === undefined || !cultures.hasOwnProperty(to.params.lang)) {
          var first = Object.keys(cultures)[0]
          var lang = store.state.language || cultures[first]

          if (!cultures.hasOwnProperty(to.params.lang)) {
            var path = '/' + lang + '/'

            if (to.params.lang) {
              path = path + to.params.lang
            }
            next({
              path: path
            })
            return false
          } else {
            store.commit('language', lang)
          }
        } else {
          store.commit('language', to.params.lang)
        }

        store.dispatch('activatePage', {
          page: name
        }).then(function (redir) {
          if (redir) {
            next({
              path: '/' + redir
            })
          } else {
            next()
          }
        })
      } else {
        next({
          path: '/not-found'
        })
      }
    })
  }
})

export default router
